/* eslint-disable */

import React, { useState } from "react";
import TablePaginate from "components/TablePaginate/TablePaginate";
import { formatTimestamp } from "../../helper/fommaters";

export default function RetroPoolActivity({
  items,
  setPage,
  page,
  count,
  size,
}) {
  const columns = React.useMemo(
    () => [
      {
        Header: "Amount",
        accessor: "amount",
      },
      {
        Header: "From",
        accessor: "from",
      },
      {
        Header: "Item",
        accessor: "item",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Time",
        accessor: "time",
        Cell: function Tier(cell) {
          return formatTimestamp(cell.value);
        },
      },
    ],
    []
  );

  return (
    <div>
      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}
